// extracted by mini-css-extract-plugin
module.exports = {"star":"reviewStars-module--star--3PvuC"};